import type { SimConfig } from './simConfig';
import {
  DEFAULT_ACTIONS,
  DEFAULT_BALL,
  DEFAULT_BOUNDS,
  DEFAULT_COLLISION,
  DEFAULT_MOVEMENT,
  DEFAULT_POSSESSION,
  DEFAULT_RULES,
  DEFAULT_AI,
  DEFAULT_SWITCHING,
} from './simConfig';
import { DEFAULT_CONDITIONS } from './conditions';
import { DEFAULT_REFEREE } from './refereeConfig';

/** The default merged SimConfig (§17 merge chain base). Grows one section per milestone. */
export const DEFAULT_SIM_CONFIG: SimConfig = Object.freeze({
  ball: DEFAULT_BALL,
  conditions: DEFAULT_CONDITIONS,
  collision: DEFAULT_COLLISION,
  movement: DEFAULT_MOVEMENT,
  bounds: DEFAULT_BOUNDS,
  actions: DEFAULT_ACTIONS,
  possession: DEFAULT_POSSESSION,
  rules: DEFAULT_RULES,
  ai: DEFAULT_AI,
  switching: DEFAULT_SWITCHING,
  referee: DEFAULT_REFEREE,
});
